import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { RadioButton } from "primereact/radiobutton";
import { ProgressSpinner } from "primereact/progressspinner";
import config from "../../../config";

// Component for adding a subject
const AddSubjectForm = ({ subject }) => {
  const [formData, setFormData] = useState(
    subject || {
      syllabusId: "",
      mediumId: null,
      name: "",
      visibility: true,
      orderId: "",
    }
  );
  const [visible, setVisible] = useState(false);
  const [syllabuses, setSyllabuses] = useState([]);
  const [syllabusOptions, setSyllabusOptions] = useState([]);
  const [mediums, setMediums] = useState([]);
  const [mediumOptions, setMediumOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);

  useEffect(() => {
    const fetchSyllabusData = async () => {
      try {
        const token = localStorage.getItem("token");
        const headersConfig = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(
          `${config.apiUrl}/syllabus`,
          headersConfig
        );
        const fetchedSyllabuses = response.data.syllabuses;
        setSyllabuses(fetchedSyllabuses);
        setSyllabusOptions(
          fetchedSyllabuses.map((syllabus) => ({
            label: syllabus.name,
            value: syllabus._id,
          }))
        );
      } catch (error) {
        console.error("Error fetching syllabuses:", error);
      }
    };

    fetchSyllabusData();
  }, []);

  useEffect(() => {
    if (formData.syllabusId) {
      const fetchMediumData = async () => {
        try {
          const token = localStorage.getItem("token");
          const headersConfig = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
          const selectedSyllabus = formData.syllabusId;
          const response = await axios.get(
            `${config.apiUrl}/medium/bySyllabus?syllabusId=${selectedSyllabus}`,
            headersConfig
          );
          const fetchedMediums = response.data.mediums;
          if (fetchedMediums && fetchedMediums.length > 0) {
            setMediums(fetchedMediums);
            setMediumOptions(
              fetchedMediums.map((medium) => ({
                label: medium.name,
                value: medium._id,
              }))
            );
          } else {
            setMediums([]);
            setMediumOptions([]);
          }
        } catch (error) {
          if (error.response && error.response.status === 404) {
            setMediums([]);
            setMediumOptions([]);
          } else {
            console.error("Error fetching mediums:", error);
          }
        }
      };

      fetchMediumData();
    }
  }, [formData.syllabusId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const response = await axios.post(
        `${config.apiUrl}/subject`,
        { ...formData, id: Date.now() },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setVisible(false);
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Subject added successfully",
      });
      window.location.reload();
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response.data.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div>
        <h3
          style={{
            float: "left",
            color: "#808080",
          }}
        >
          Subjects
        </h3>
        <Button
          label="+ New Subject"
          onClick={() => setVisible(true)}
          style={{ float: "right" }}
          rounded
          text
          raised
        />
        <br />
        <br />
        <br />
      </div>
      <Dialog
        header="Add Subject"
        visible={visible}
        onHide={() => setVisible(false)}
        style={{ width: "700px", maxHeight: "600px" }}
      >
        <div className="p-fluid">
          <div style={{ display: "flex" }}>
            <div
              className="p-field"
              style={{
                marginBottom: "20px",
                marginRight: "20px",
                width: "50%",
              }}
            >
              <label htmlFor="syllabusId">Syllabus</label>
              <Dropdown
                id="syllabusId"
                name="syllabusId"
                value={formData.syllabusId}
                options={syllabusOptions}
                onChange={handleChange}
                optionLabel="label"
                optionValue="value"
                placeholder="Select Syllabus"
                style={{ marginTop: "10px" }}
              />
            </div>
            <div
              className="p-field"
              style={{ marginBottom: "20px", width: "50%" }}
            >
              <label htmlFor="mediumId">Medium</label>
              <Dropdown
                id="mediumId"
                name="mediumId"
                value={formData.mediumId}
                options={mediumOptions}
                onChange={handleChange}
                optionLabel="label"
                optionValue="value"
                placeholder="Select Medium"
                style={{ marginTop: "10px" }}
              />
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              className="p-field"
              style={{
                marginBottom: "20px",
                marginRight: "20px",
                width: "50%",
              }}
            >
              <label htmlFor="name">Name</label>
              <InputText
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                style={{ marginTop: "10px" }}
              />
            </div>
            <div
              className="p-field"
              style={{ marginBottom: "20px", width: "50%" }}
            >
              <label htmlFor="orderId">
                Order ID&nbsp;&nbsp;
                <small style={{ color: "#808080", fontStyle: "italic" }}>
                  (Optional)
                </small>
              </label>
              <InputText
                id="orderId"
                name="orderId"
                value={formData.orderId || ""}
                keyfilter="int"
                onChange={handleChange}
                style={{ marginTop: "10px" }}
              />
            </div>
          </div>
          <div className="p-field">
            <label htmlFor="visibility">Visibility</label>
            <br></br>
            <RadioButton
              id="visibility"
              name="visibility"
              value={true}
              onChange={handleChange}
              checked={formData.visibility === true}
              style={{ marginTop: "10px" }}
            />{" "}
            Yes &nbsp;
            <RadioButton
              id="visibility"
              name="visibility"
              value={false}
              onChange={handleChange}
              checked={formData.visibility === false}
              style={{ marginTop: "10px" }}
            />{" "}
            No
          </div>
        </div>
        <div
          className="p-dialog-footer"
          style={{
            marginTop: "20px",
            marginBottom: "-20px",
            marginRight: "-24px",
          }}
        >
          <Button
            label="Cancel"
            onClick={() => setVisible(false)}
            severity="danger"
            outlined
          />
          <Button
            label={
              loading ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  Saving...&nbsp;&nbsp;
                  <ProgressSpinner
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "5px",
                    }}
                  />
                </div>
              ) : (
                "Save"
              )
            }
            onClick={handleSubmit}
            severity="success"
            outlined
            disabled={loading}
          />
        </div>
      </Dialog>
      <Toast ref={toast} />
    </div>
  );
};

export default AddSubjectForm;
